module.exports = __webpack_public_path__ + "img/facebook.227fd82b.svg";